<template>
  <Card :bordered='false' class='border-radius-0'>
    <Form :ref='(e) => (refs.form = e)' layout='horizontal'>
      <TemplateBuilder :rowProp='data.rowProp' :useForm='data.useForm' :fields='data.fields'
                       :skeleton='isLoading'></TemplateBuilder>
    </Form>
    <ChangeLogCollapse
        class='mt-2'
        v-if='visibleChangeLog && data.id'
        :id='data.id'
        :onCallChangeLog='({ id, page, size }) => onCallChangeLog({ id, page, size, createSearchOneCriteria, callChanges })'
        :mappings='data.changeLogFields'
    ></ChangeLogCollapse>
  </Card>
</template>

<script>
import {computed, defineAsyncComponent, defineComponent, reactive} from 'vue';
import {Card, Form} from 'ant-design-vue';
import {matchMenu} from '../../../../../utils/menu-context';
import {state as stateApp} from '../../../../../app.logic';
import {useRoute} from 'vue-router';

import {
    callChanges,
    createFormTitle,
    createSearchOneCriteria,
    initForm,
    onClickModalOk,
} from './topic-unit-form.logic';

import {
    isLoading,
    state
} from './topic-unit-list.logic';

import {onCallChangeLog} from '../../../../../utils/form';

export default defineComponent({
  components: {
    Card,
    Form,
    TemplateBuilder: defineAsyncComponent(() => import('../../../../../components/input/template-builder/TemplateBuilder')),
    ChangeLogCollapse: defineAsyncComponent(() => import('../../../../../components/change-log/ChangeLogCollapse')),
  },
  props: {
    menuContext: {default: () => matchMenu('/app/master-mgt/lab/topic-units', stateApp.authInfo.menus)},
    viewOnly: {default: false},
    form: {},
    setAppPageHeader: {default: true},
    visibleChangeLog: {default: true},
  },
  setup(props) {
    const route = useRoute();
    const id = props.form ? props.form.id : route.params?.id;
    const data = reactive({rowProp: {gutter: 24}, id, section: {}, changeLogFields: []});
    const refs = reactive({form: null});
    initForm({props, data, refs});
    const callOnClickModalOk = () => onClickModalOk({props, data, refs});
    const title = computed(() => createFormTitle({props, data, refs}));
    return {
      props,
      data,
      refs,
      state,
      title,
      isLoading,
      callChanges,
      callOnClickModalOk,
      createSearchOneCriteria,
      onCallChangeLog,
    };
  },

});
</script>

<style>

</style>
